import markApplicationService from "./markApplicationService";

const cropMarkApplicationService = [
    ...markApplicationService
]

export default cropMarkApplicationService;